import { jsx as _jsx } from "react/jsx-runtime";
const CurrencyInput = ({ id, value = "", placeholder = "", onChange }) => {
    return (_jsx("input", { className: "p-2 w-full border border-wfGray-300 focus:border-salmon-600 focus:border-2", id: id, name: id, type: "text", onChange: (ev) => { onChange(ev); }, defaultValue: value, placeholder: "Add a cool name" }));
};
export default CurrencyInput;
